import Vue from 'vue'
import _ from 'lodash'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    tournamentsList: {
      liveFilter: true,
    },

    matchLiveInformation: {},
  },

  mutations: {
    setMatchLiveInformation (state, matchLiveInformation) {
      state.matchLiveInformation = matchLiveInformation
    },

    removeMatchLiveInformation (state) {
      state.matchLiveInformation = {}
    },

    updateOrCreateTournament (state, { code, localState }) {
      if (state.tournamentsList[code] === undefined) {
        return state.tournamentsList[code] = localState
      }

      localState.matches.forEach((updatedMatch) => {
        const index = _.findIndex(state.tournamentsList[code].matches, (match) => {
          return match.no === updatedMatch.no
        })

        state.tournamentsList[code].matches[index] = updatedMatch
      })

      state.tournamentsList[code].version = localState.version
    },

    toggleTournamentLiveFilter (state) {
      state.tournamentsList.liveFilter = !state.tournamentsList.liveFilter
    }
  },
})



// WEBPACK FOOTER //
// ./src/store/index.js